module.exports = __webpack_public_path__ + "img/Andrea-Virreira.4ec27827.png";